var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx } from "react/jsx-runtime";
import CList from "./CList";
import { useSearchParams } from "react-router-dom";
import { useQuery } from "react-query";
import { useEffect, useRef, useState } from "react";
import { GeneralSet } from "../../utils/generalSet";
import { useTranslation } from "react-i18next";
export var useList = function (props) {
    var externalDeps = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        externalDeps[_i - 1] = arguments[_i];
    }
    var _a = useTranslation(), t = _a.t, i18n = _a.i18n;
    var paramName = function (name) {
        return props.listId ? "".concat(props.listId).concat(name) : name;
    };
    var _b = useSearchParams(), searchParams = _b[0], setSearchParams = _b[1];
    var pageParam = searchParams.get(paramName('ListPage'));
    var page = 1;
    if (pageParam && !isNaN(parseInt(pageParam))) {
        page = parseInt(pageParam);
    }
    var sizeParam = searchParams.get(paramName('ListSize'));
    var size = props.defaultPageSize || 10;
    if (sizeParam && !isNaN(parseInt(sizeParam))) {
        size = parseInt(sizeParam);
    }
    useEffect(function () {
        if (props.showAllItems) {
            searchParams.set(paramName('ListPage'), '1');
            searchParams.set(paramName('ListSize'), '500');
            setSearchParams(searchParams);
        }
    }, [props.showAllItems]);
    var sortProp = searchParams.get(paramName('ListSortProp')) || props.initialSortProp || 'id';
    var sortDir = (searchParams.get(paramName('ListSortDir')) || props.initialSortDir || 'DESC');
    var search = searchParams.get(paramName('ListSearch')) || '';
    var timeOfInit = useState(new Date())[0];
    var _c = useState(new GeneralSet()), selected = _c[0], setSelected = _c[1];
    var _d = useState(false), loading = _d[0], setLoading = _d[1];
    var _e = useState(false), exporting = _e[0], setExporting = _e[1];
    var forceUpdate = function () {
        setActiveColumns(getActiveColumns());
    };
    var getActiveColumns = function () {
        var _a, _b;
        if (props.forceAllColumns) {
            if ((_a = props.allColumns) === null || _a === void 0 ? void 0 : _a.length) {
                return props.allColumns || [];
            }
            else {
                return props.columns || [];
            }
        }
        if (!((_b = props.allColumns) === null || _b === void 0 ? void 0 : _b.length)) {
            return props.columns || [];
        }
        var storedColumns = localStorage.getItem("".concat(props.listId, "-columns"));
        if (storedColumns) {
            var parsedColumns = JSON.parse(storedColumns);
            if (Array.isArray(parsedColumns) && parsedColumns.length) {
                try {
                    // Make sure to filter out columns that are not in the list of all columns
                    var allColumns_1 = props.allColumns || props.columns || [];
                    var columnIds_1 = allColumns_1.map(function (c) { return c.id; });
                    var filteredColumns_1 = parsedColumns.filter(function (c) { return columnIds_1.includes(c === null || c === void 0 ? void 0 : c.id); });
                    // Make sure that each filtere colum has width from original allColumns
                    // matched by id
                    filteredColumns_1.forEach(function (c, i) {
                        var allColumn = allColumns_1.find(function (ac) { return ac.id === c.id; });
                        if (allColumn) {
                            filteredColumns_1[i].width = allColumn.width;
                            filteredColumns_1[i].name = allColumn.name;
                            filteredColumns_1[i].sortProp = allColumn.sortProp;
                            filteredColumns_1[i].initialSortDir = allColumn.initialSortDir;
                            filteredColumns_1[i].hideOnPrint = allColumn.hideOnPrint;
                        }
                    });
                    if (filteredColumns_1.length) {
                        return filteredColumns_1;
                    }
                    else {
                        return props.columns || [];
                    }
                }
                catch (e) {
                    return props.columns || [];
                }
            }
            else {
                return props.columns || [];
            }
        }
        return props.columns || [];
    };
    var _f = useState(getActiveColumns), activeColumns = _f[0], setActiveColumns = _f[1];
    // Track which allColumns ids we have already reconciled into the active set.
    // Columns can be discovered dynamically after mount (e.g. dynamic form-answer
    // columns). Newly appearing columns should show up automatically while
    // remaining deselectable — once seen, a deselected column is not re-added.
    var seenColumnIdsRef = useRef(new Set((props.allColumns || []).map(function (c) { return c.id; })));
    useEffect(function () {
        var _a;
        if (props.forceAllColumns)
            return;
        if (!((_a = props.allColumns) === null || _a === void 0 ? void 0 : _a.length))
            return;
        var newColumns = props.allColumns.filter(function (c) { return !seenColumnIdsRef.current.has(c.id); });
        if (!newColumns.length)
            return;
        newColumns.forEach(function (c) { return seenColumnIdsRef.current.add(c.id); });
        setActiveColumns(function (prev) {
            var existingIds = new Set(prev.map(function (c) { return c.id; }));
            var toAdd = newColumns.filter(function (c) { return !existingIds.has(c.id); });
            return toAdd.length ? __spreadArray(__spreadArray([], prev, true), toAdd, true) : prev;
        });
    }, [JSON.stringify((props.allColumns || []).map(function (c) { return c.id; })), props.forceAllColumns]);
    // filter rules are stored in url params as base64 encoded json
    var _g = useState(function () {
        var filterParam = searchParams.get(paramName('ListFilter'));
        if (filterParam) {
            var value = JSON.parse(atob(filterParam));
            if (Array.isArray(value) && value.length) {
                return value;
            }
            else {
                return props.defaultFilterRules || [];
            }
        }
        return props.defaultFilterRules || [];
    }), filterRules = _g[0], setFilterRules = _g[1];
    // Whenever defaultFilterRules change, update the filterRules state and the url params
    useEffect(function () {
        if (props.defaultFilterRules) {
            setFilterRules(props.defaultFilterRules);
            searchParams.set(paramName('ListFilter'), btoa(JSON.stringify(props.defaultFilterRules)));
            searchParams.set(paramName('ListPage'), '1');
            setSearchParams(searchParams);
        }
    }, [JSON.stringify(props.defaultFilterRules)]);
    useEffect(function () {
        if (props.defaultActiveColumns !== undefined) {
            setActiveColumns(props.defaultActiveColumns);
        }
    }, [JSON.stringify(props.defaultActiveColumns)]);
    useEffect(function () {
        localStorage.setItem("".concat(props.listId, "-columns"), JSON.stringify(activeColumns));
    }, [activeColumns, props.listId]);
    useEffect(function () {
        setActiveColumns(getActiveColumns());
    }, [i18n.language]);
    var fetchItems = function () { return __awaiter(void 0, void 0, void 0, function () {
        var result;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    // if (loading) return
                    setLoading(true);
                    return [4 /*yield*/, ((_a = props.list) === null || _a === void 0 ? void 0 : _a.call(props, page - 1, size, search, sortProp, sortDir, filterRules))
                        // setItems(result)
                    ];
                case 1:
                    result = _c.sent();
                    // setItems(result)
                    (_b = props.onFetched) === null || _b === void 0 ? void 0 : _b.call(props, (result === null || result === void 0 ? void 0 : result.content) || []);
                    setLoading(false);
                    return [2 /*return*/, result];
            }
        });
    }); };
    // useEffect(() => {
    //     if (differenceInMilliseconds(new Date(), timeOfInit) > 400) {
    //         searchParams.set(paramName('ListPage'), '1')
    //         setSearchParams(searchParams)
    //         // pageLocalRef.current = 1
    //         // setPage(1)
    //     }
    // }, externalDeps)
    useEffect(function () {
        setSelected(new GeneralSet());
    }, __spreadArray([props.listId, page, size, search, sortProp, sortDir, JSON.stringify(filterRules)], externalDeps, true));
    var query = useQuery(__spreadArray([props.listId, page, size, search, sortProp, sortDir, filterRules], externalDeps, true), fetchItems, {
        staleTime: props.staleTime,
        refetchInterval: props.refetchInterval,
        keepPreviousData: true
    });
    var refresh = function () { return query.refetch(); };
    var items = query.data;
    // useEffect(() => {
    //     fetchItems()
    // }, [size, page, search])
    var setItems = function (_) {
    };
    var handleSearch = function (query) {
        // pageLocalRef.current = 1
        // searchLocalRef.current = query
        //
        // setMultipleParams([
        //     {name: paramName('ListPage'), value: '1'},
        //     {name: paramName('ListSearch'), value: query},
        // ], location, navigate)
        searchParams.set(paramName('ListPage'), '1');
        searchParams.set(paramName('ListSearch'), query);
        setSearchParams(searchParams);
    };
    var exportData = function () { return __awaiter(void 0, void 0, void 0, function () {
        var e_1;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, 3, 4]);
                    setExporting(true);
                    return [4 /*yield*/, ((_a = props.exportData) === null || _a === void 0 ? void 0 : _a.call(props, search, sortProp, sortDir))];
                case 1:
                    _b.sent();
                    return [3 /*break*/, 4];
                case 2:
                    e_1 = _b.sent();
                    console.log(e_1);
                    return [3 /*break*/, 4];
                case 3:
                    setExporting(false);
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var renderList = function () {
        var _a, _b, _c;
        return (_jsx(CList, { items: items === null || items === void 0 ? void 0 : items.content, columns: props.forceAllColumns ? getActiveColumns() : activeColumns, setColumns: setActiveColumns, allColumns: props.forceAllColumns ? getActiveColumns() : props.allColumns, extractKey: props.extractKey, renderCell: function (item, column, index, allItems) { var _a; return ((_a = props.renderCell) === null || _a === void 0 ? void 0 : _a.call(props, item, column, index, allItems, query.refetch, sortProp, sortDir)) || null; }, renderRowAdditionalContent: props.renderRowAdditionalContent, rowStyle: props.rowStyle, headerStyle: props.headerStyle, size: size, onSizeChange: function (size) {
                // sizeLocalRef.current = size
                // pageLocalRef.current = 1
                // setMultipleParams([
                //     {name: paramName('ListSize'), value: size.toString()},
                //     {name: paramName('ListPage'), value: `1`}
                // ], location, navigate)
                searchParams.set(paramName('ListPage'), '1');
                searchParams.set(paramName('ListSize'), "".concat(size));
                setSearchParams(searchParams);
            }, page: page, onPageChange: function (page) {
                // setPage(page)
                // pageLocalRef.current = page
                searchParams.set(paramName('ListPage'), "".concat(page));
                setSearchParams(searchParams);
            }, totalPages: (items === null || items === void 0 ? void 0 : items.totalPages) || 0, totalElements: (items === null || items === void 0 ? void 0 : items.totalElements) || 0, onItemClick: props.onItemClick, searchQuery: search || '', onSearch: props.searchable ? handleSearch : undefined, multiselect: props.multiselect, selected: selected, onSelect: function (user) {
                if (selected.has(user)) {
                    setSelected(selected.deleteImmutable(user));
                }
                else {
                    setSelected(selected.addImmutable(user));
                }
            }, onSelectAll: function () {
                var _a;
                if (((_a = items === null || items === void 0 ? void 0 : items.content) === null || _a === void 0 ? void 0 : _a.length) && selected.size() === items.content.length) {
                    setSelected(new GeneralSet());
                }
                else {
                    setSelected(new GeneralSet(items === null || items === void 0 ? void 0 : items.content));
                }
            }, classes: props.classes, onAdd: props.onAdd, 
            // showing loader by default, but can be overridden by props.showLoader
            loading: ((_a = props.showLoader) !== null && _a !== void 0 ? _a : true) && loading, styles: props.styles, sortProp: sortProp, sortDir: sortDir, onChangeSort: function (sortProp, sortDir) {
                // sortPropLocalRef.current = sortProp
                // sortDirLocalRef.current = sortDir
                //
                // setMultipleParams([
                //     {name: paramName('ListSortProp'), value: sortProp},
                //     {name: paramName('ListSortDir'), value: sortDir},
                // ], location, navigate)
                //
                // const currentSortProp = searchParams.get(paramName('ListSortProp'));
                // const currentSortDir = searchParams.get(paramName('ListSortDir'));
                //
                // let newSortDir;
                // if (currentSortProp === sortProp) {
                //     // Toggle direction
                //     newSortDir = currentSortDir === 'ASC' ? 'DESC' : 'ASC';
                // } else {
                //     // Default to ascending when changing the sort property
                //     newSortDir = 'ASC';
                // }
                searchParams.set(paramName('ListSortProp'), sortProp);
                searchParams.set(paramName('ListSortDir'), sortDir);
                setSearchParams(searchParams);
            }, customPageSizes: props.customPageSizes, defaultPageSize: props.defaultPageSize, actionBar: (_b = props.actionBar) === null || _b === void 0 ? void 0 : _b.call(props, items, setItems, selected, setSelected, fetchItems, loading), searchActions: (_c = props.searchActions) === null || _c === void 0 ? void 0 : _c.call(props, items, setItems, selected, setSelected, fetchItems, loading), renderMobileView: props.renderMobileView, floatingFooter: props.floatingFooter, id: props.listId, filterOptions: props.filterOptions, forceSectorId: props.forceSectorId, filterRules: filterRules, setFilterRules: function (rules) {
                setFilterRules(rules);
                searchParams.set(paramName('ListFilter'), btoa(JSON.stringify(rules)));
                searchParams.set(paramName('ListPage'), '1');
                setSearchParams(searchParams);
            }, onResetColumns: function () {
                localStorage.removeItem("".concat(props.listId, "-columns"));
                setActiveColumns(props.columns || []);
            }, contentRef: props.contentRef, printHeader: props.printHeader, printFooter: props.printFooter, emptyComponent: props.emptyComponent, rightHandSideSearch: props.rightHandSideSearch, searchBarOpenTriggered: props.searchBarOpenTriggered }));
    };
    return {
        items: items,
        page: page,
        setItems: setItems,
        // sizeLocal,
        // setSizeLocal,
        // pageLocal,
        // setPageLocal,
        // searchLocal,
        // setSearchLocal,
        selected: selected,
        setSelected: setSelected,
        fetchItems: fetchItems,
        refresh: refresh,
        renderList: renderList,
        loading: query.status === 'loading',
        exporting: exporting,
        exportData: exportData,
        onPageChange: function (page) {
            searchParams.set(paramName('ListPage'), "".concat(page));
            setSearchParams(searchParams);
        },
        size: size,
        setSize: function (size) {
            searchParams.set(paramName('ListPage'), '1');
            searchParams.set(paramName('ListSize'), "".concat(size));
            setSearchParams(searchParams);
        },
        search: search,
        filterRules: filterRules,
        forceUpdate: forceUpdate,
    };
};
